export const INTERACTION_TYPES = {
  none: 'none',
  sortable: 'sortable',
  nestable: 'nestable',
};
